<template>
  <div>
    <template v-if="!loading">

      <b-row align-v="center">
        <b-col lg="4">
          <h6 class="h6-semibold-azure-uppercase">{{ current.pad(2) }}</h6>
          <h3 class="h3-semibold-black mb-5">Che tipo di impresa sei?</h3>
        </b-col>
        <b-col lg="6" offset-lg="2">
          <b-row>
            <b-col cols="6" class="pb-3">
              <div class="config-button-element" @click="setCompanyType('professionista')">
                <i class="sgri-partita-iva-bicolore">
                  <span class="path1"></span>
                  <span class="path2"></span>
                  <span class="path3"></span>
                  <span class="path4"></span>
                  <span class="path5"></span>
                  <span class="path6"></span>
                  <span class="path7"></span>
                  <span class="path8"></span>
                  <span class="path9"></span>
                </i>
                <div class="title h6-semibold-azure-uppercase">Artigiano<br>Professionista</div>
              </div>
            </b-col>
            <b-col cols="6" class="pb-3">
              <div class="config-button-element" @click="setCompanyType('pmi')">
                <i class="sgri-piccola-media-impresa-bicolore">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
                <div class="title h6-semibold-azure-uppercase">PMI</div>
              </div>
            </b-col>
            <b-col cols="6" class="pb-3">
              <div class="config-button-element" @click="setCompanyType('albergo')">
                <i class="sgri-albergo-bicolore">
                  <span class="path1"></span>
                  <span class="path2"></span>
                  <span class="path3"></span>
                </i>
                <div class="title h6-semibold-azure-uppercase">Albergo</div>
              </div>
            </b-col>
            <b-col cols="6" class="pb-3">
              <div class="config-button-element" @click="setCompanyType('condominio')">
                <i class="sgri-condominio-bicolore">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
                <div class="title h6-semibold-azure-uppercase">Condominio</div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

    </template>
  </div>
</template>

<script>
export default {
  name: 'Step-3',
  data() {
    return {
      thisStep: 3,
      localOptions: null,
      loading: true,
    }
  },
  props: {
    steps: {
      type: Number,
      required: true,
    },
    current: {
      type: Number,
      default: 1,
    },
    options: {
      type: [Array, Object],
      required: true
    }
  },
  created() {
    if(this.options.step < this.thisStep) this.$router.push({name:'step-1', query: { comune: this.options.comune }})
    this.$emit('setCurrent', this.thisStep)
    this.localOptions = {...this.options};
    this.loading = false;
    this.trackFbViewContent('configuratore', 'step-3');
  },
  methods: {
    setCompanyType(type) {
      this.localOptions.companyType = type;
      let nextStep = 7;
      let realNextStep = 7;
      this.$emit('nextStep',nextStep, realNextStep, this.localOptions)
    },
  },
}
</script>

<style scoped lang="scss">
</style>